// extracted by mini-css-extract-plugin
export default {"container":"CascadeInputNumber_container__Yo95B","input":"CascadeInputNumber_input__paQAh"};